import { isDefectColumn } from './ddp';

const cardSize = {
  height: 58,
  heightSm: 32,
  width: 310,
  widthLg: 496,
  marginRight: 32,
  sidebarToggleWidth: 2,
};
const tableSize = {
  paddingX: 24,
  headerWidth: 144,
  columnMarginRight: 32,
  emptyRowHeight: 78,
};
const getCardWidth = (noColumns: number) => (noColumns <= 3 ? cardSize.widthLg : cardSize.width);
export const totalWidth = (columns: string[]) =>
  columns.reduce((sum, col) => sum + getColumnWidthForType(columns.length, isDefectColumn(col)), 0) +
  tableSize.paddingX * 2 +
  tableSize.headerWidth;
const getSidepanelToggleWidth = (noColumns: number) => getCardWidth(noColumns) + cardSize.sidebarToggleWidth;

export const getColumnWidth = (noColumns: number) => getSidepanelToggleWidth(noColumns) + tableSize.columnMarginRight;

const COLUMN_MIN_WIDTH_DEFECT = 320;
const COLUMN_MIN_WIDTH_OVERIG = 256;

export const getColumnWidthForType = (noColumns: number, isDefect: boolean): number =>
  noColumns <= 3
    ? getSidepanelToggleWidth(noColumns) + tableSize.columnMarginRight
    : isDefect
      ? COLUMN_MIN_WIDTH_DEFECT
      : COLUMN_MIN_WIDTH_OVERIG;

export const getSidepanelToggleWidthForType = (noColumns: number, isDefect: boolean): number =>
  getColumnWidthForType(noColumns, isDefect) - tableSize.columnMarginRight;

export const getCardWidthForType = (noColumns: number, isDefect: boolean): number =>
  getSidepanelToggleWidthForType(noColumns, isDefect) - cardSize.sidebarToggleWidth;

export const adjustMatTypeLength = (matType: string): string => matType;
